/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Device_MacInputs */

const en_funnel_device_mac = /** @type {(inputs: Funnel_Device_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac`)
};

const es_funnel_device_mac = /** @type {(inputs: Funnel_Device_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mac`)
};

/**
* | output |
* | --- |
* | "Mac" |
*
* @param {Funnel_Device_MacInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_device_mac = /** @type {((inputs?: Funnel_Device_MacInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Device_MacInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_device_mac(inputs)
	return en_funnel_device_mac(inputs)
});